// @flow
import useRightsByOrgData from './useRightsByOrgData';


export default function useInitFunc() {
  const [, { initRights }] = useRightsByOrgData();

  return initRights;
}
